/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Automatic from './Automatic/index'
import Manual from './Manual/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/StatusUpdate/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let automationAutomationTypeValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'automation_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: automationAutomationTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Automatic'}>
<Automatic
  viewPath={`${viewPath}/Automatic`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Manual'}>
<Manual
  viewPath={`${viewPath}/Manual`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}